// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__1napr","desabilitar":"OptionSelect_desabilitar__1Tu0v","focado":"OptionSelect_focado__3qZhv","novo":"OptionSelect_novo__1EBHJ"};